import styled from "styled-components";
import { COLOR } from "../../../constants";

export const LoadingBar = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: ${props => props.height || 4}px;
  background: ${props => props.color || COLOR.LOADING_BAR};
  transform: scaleX(${props => props.progress / 100});
  transform-origin: left;
  transition: transform 0.3s ease;
  z-index: 9999;
`;
